import { clientEnvModule } from "@/modules/client-env";

/**
 * Gets the current window's origin for web environments.
 * Returns undefined for desktop environments where origin is not applicable.
 * Used for CORS-enabled upload requests that require origin header.
 */
export const getWindowOrigin = (): string | undefined => {
  const isDesktop = clientEnvModule.isDesktop();
  if (isDesktop) return undefined;

  // eslint-disable-next-line no-restricted-properties
  return window.location.origin;
};
